<script>
export default {
  name: "TheMobileTopMenu",
  props: {
    menuItems: {
      type: Object,
      default: () => {
        return {
          topMenuItems: [],
          ctaMenuItems: []
        }
      }
    }
  }
}
</script>

<template>
  <div id="mobile-menu" class="main-menu-wrapper container-fluid text-black">
    <div class="offcanvas offcanvas-end w-100" tabindex="-1" id="offcanvasNavbar">
      <div class="offcanvas-header d-flex align-items-center bg-ck-blue text-white px-3">
        <div href="/" class="navbar-brand logo-wrapper me-auto d-flex">
          <img class="logo-image align-self-center" src="/local/images/ck-header/ck-header-logo.png"
               alt="Card Kingdom Logo"/>
          <img class="mobile-logo-title align-self-center ps-1 d-block d-sm-none"
               src="/local/images/ck-header/ck-xs-header-title.png" alt="Card Kingdom Logo Title"/>
          <img class="logo-title align-self-center ps-2 d-none d-sm-block" alt="Card Kingdom Logo Title"
               src="/local/images/ck-header/ck-header-title.png"/>
        </div>
        <i class="fa-solid fa-xmark fs-2" data-bs-dismiss="offcanvas" aria-label="Close"></i>
      </div>
      <div class="offcanvas-body">
        <ul class="mainmenu-top-level-items navbar-nav justify-content-end flex-grow-1">
          <li
              class="submenu-toggle mobile-menu-only" data-menu="menu-myaccount"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasSubmenu0" aria-controls="offcanvasSubmenu0Navbar">
            <span>MY ACCOUNT</span><i class="fa-solid fa-angle-right"></i>
          </li>
          <li
              v-for="(menu, index) in menuItems.topMenuItems"
              :key="menu.menu_title_text"
              class="submenu-toggle text-uppercase"
              data-menu="menu-mtg" data-bs-toggle="offcanvas"
              :data-bs-target="`#offcanvasSubmenu${index+1}`" :aria-controls="`offcanvasSubmenu${index+1}Navbar`">
            <span>{{ menu.menu_title_text }}</span><i class="fa-solid fa-angle-right"></i>
          </li>
          <li
              v-for="menu in menuItems.ctaMenuItems"
              :key="menu._metadata.uid"
              class="submenu-link mobile-menu-only" :data-menu="`menu-${menu.link.title}`">
            <a :title="menu.link.title"
               :href="menu.link.href">
              {{ menu.link.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
